import Config from 'utils/getEnvConfig';
import { isBot, isLocalhost } from 'utils/stringUtils';

// enable only in production mode
const activeIntercom = !isLocalhost && !isBot();

const APP_ID = Config.INTERCOM_ID;

const intercomActions = {
  init: () => {
    if (activeIntercom) {
      // eslint-disable-next-line
      (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
    }
  },
  boot: user_id => {
    if (activeIntercom) {
      window.Intercom('boot', {
        app_id: Config.INTERCOM_ID,
        user_id,
      });
    }
  },
  update: () => {
    if (activeIntercom) {
      window.Intercom('update', {
        last_request_at: parseInt(new Date().getTime() / 1000, 10),
      });
    }
  },
  track: eventName => {
    if (activeIntercom) {
      window.Intercom('trackEvent', eventName, {
        path: window.location.pathname,
      });
    }
  },
};

export default intercomActions;
